import { useContext } from "react";
import { MaintananceContext } from "../context";

export const useMaintainance = () => useContext(MaintananceContext);
